<template>
    <div v-if="inputVal">
        <student-worksheet-module-wrapper
            :module="module"
            :module-complete="response.module_complete"
            :worksheet-complete="worksheetComplete"
        >
            <div class="px-8">
                <div
                    :class="
                        'mb-4 grid select-none grid-cols-2 gap-4' +
                        ' ' +
                        'lg:grid-cols-' +
                        Math.min(4, categories.length)
                    "
                >
                    <div
                        :class="
                            'flex-grow rounded border border-neutral-20 text-center' +
                            ' ' +
                            (response.module_complete
                                ? 'bg-green-50'
                                : 'bg-white')
                        "
                        v-for="(category, cIndex) in categories"
                    >
                        <div
                            class="rounded-t border-green-400 bg-green-400 p-2 text-center text-[18px] font-semibold text-white"
                        >
                            {{ category.title }}
                        </div>
                        <div class="min-h-[8rem] p-4">
                            <draggable
                                v-model="categories[cIndex].items"
                                :disabled="response.module_complete"
                                :group="'items' + ' ' + module.id"
                                ghost-class="ghost"
                                animation="0"
                                @change="onMove"
                                itemKey="title"
                                empty-insert-threshold="50"
                            >
                                <div v-for="option in categories[cIndex].items">
                                    <div
                                        :class="
                                            'm-2 mb-2 cursor-pointer rounded border p-1 text-[14px] font-semibold' +
                                            ' ' +
                                            (getItemInCorrectCategory(
                                                option,
                                                categories[cIndex]
                                            )
                                                ? 'border-green-400 bg-green-400 text-white'
                                                : 'border-red-400 bg-red-400 text-white') +
                                            ' '
                                        "
                                    >
                                        {{ option.title }}
                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </div>
                </div>
                <div class="rounded border border-neutral-20 text-center">
                    <div class="min-h-[4rem] p-4">
                        <div
                            :class="
                                response.module_complete
                                    ? 'opacity-30'
                                    : 'opacity-100'
                            "
                        >
                            <div class="font-14 select-none">
                                <draggable
                                    :disabled="response.module_complete"
                                    class="flex flex-wrap gap-2"
                                    :group="'items' + ' ' + module.id"
                                    ghost-class="ghost"
                                    animation="0"
                                    itemKey="title"
                                    v-model="remainingOptions"
                                >
                                    <div v-for="option in remainingOptions">
                                        <div
                                            :class="
                                                'm-2 mb-2 cursor-pointer rounded border border-gray-325 bg-gray-225 p-1 text-[14px] font-semibold' +
                                                ' ' +
                                                (response.module_complete
                                                    ? 'opacity-50'
                                                    : '')
                                            "
                                        >
                                            {{ option.title }}
                                        </div>
                                    </div>
                                </draggable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </student-worksheet-module-wrapper>
    </div>
    <div class="hidden lg:grid-cols-3 lg:grid-cols-4 lg:grid-cols-5"></div>
</template>

<script>
import StudentWorksheetModuleWrapper from "./StudentWorksheetModuleWrapper";
import { VueDraggableNext } from "vue-draggable-next";
import { includes } from "lodash";

export default {
    name: "StudentWorksheetModuleCategorize",
    components: {
        StudentWorksheetModuleWrapper,
        draggable: VueDraggableNext,
    },
    props: ["modelValue", "module", "worksheetComplete"],
    data() {
        return {
            response: {},
            categories: [],
            remainingOptions: [],
            ready: false,
        };
    },
    methods: {
        includes,
        onMove: function (evt) {
            this.checkPositions();

            this.response = {
                categories: this.categories,
                remaining_options: this.remainingOptions,
                module_complete: this.checkPositions(),
            };

            this.inputVal = this.response;
        },
        checkPositions: function () {
            let allCorrect = true;
            const sameTitles = {};

            this.categories.forEach((category) => {
                category.items.forEach((item) => {
                    if (!Array.isArray(sameTitles[item.title])) {
                        sameTitles[item.title] = [];
                    }
                    sameTitles[item.title].push(item);
                });
            });

            const categoriesWithSameTitles = {};
            Object.keys(sameTitles).forEach((title) => {
                if (sameTitles[title].length < 2) {
                    delete sameTitles[title];
                }
            });

            const sameTitleKeys = Object.keys(sameTitles);

            this.remainingOptions.forEach(function (item) {
                if (!item.is_distractor) {
                    allCorrect = false;
                }
            });

            // if (!allCorrect) {
            //     return false;
            // }

            sameTitleKeys.forEach((sameTitle) => {
                sameTitles[sameTitle].forEach((title) => {
                    if (!categoriesWithSameTitles[title.correct_category]) {
                        categoriesWithSameTitles[title.correct_category] = {};
                    }
                    if (
                        !categoriesWithSameTitles[title.correct_category][
                            title.title
                        ]
                    ) {
                        categoriesWithSameTitles[title.correct_category][
                            title.title
                        ] = 0;
                    }
                    categoriesWithSameTitles[title.correct_category][
                        title.title
                    ]++;
                });
            });

            const categoriesWithSameTitlesKeys = Object.keys(
                categoriesWithSameTitles
            );

            this.categories.forEach(function (category) {
                category.items.forEach(function (item) {
                    // Checking options with same titles separately
                    if (sameTitles[item.title]) {
                        // return;
                    }
                    if (item.correct_category !== category.title) {
                        allCorrect = false;
                    }
                });
            });

            if (!allCorrect) {
                return false;
            }

            let categoryMissing = false;
            if (sameTitleKeys.length > 0) {
                const cats = this.categories.filter((category) => {
                    let foundCount = 0;
                    if (category.items.length > 0) {
                        let found = false;

                        category.items.forEach((item) => {
                            if (categoriesWithSameTitles[category.title]) {
                                if (
                                    categoriesWithSameTitles[category.title][
                                        item.title
                                    ]
                                ) {
                                    foundCount++;
                                }

                                if (
                                    foundCount ===
                                    categoriesWithSameTitles[category.title][
                                        item.title
                                    ]
                                ) {
                                    found = true;
                                }
                            }
                        });

                        return found;
                    }
                });

                if (cats.length !== categoriesWithSameTitlesKeys.length) {
                    categoryMissing = true;
                }
            }

            return allCorrect && !categoryMissing;
        },
        getItemInCorrectCategory(item, currentCategory) {
            let vm = this;
            let correctlyPlaced = false;
            let categoryItems = [];

            vm.module.content.categories.forEach(function (category) {
                categoryItems = [];

                category.items.forEach(function (item) {
                    categoryItems.push(item);
                });

                if (
                    category.title == currentCategory.title &&
                    _.includes(categoryItems, item.title)
                ) {
                    correctlyPlaced = true;
                }
            });

            console.log(correctlyPlaced);

            return correctlyPlaced;
        },
    },
    mounted() {
        let vm = this;

        if (!vm.modelValue) {
            vm.module.content.categories.forEach(function (category) {
                vm.categories.push({ title: category.title, items: [] });
                category.items.forEach(function (item) {
                    vm.remainingOptions.push({
                        title: item,
                        correct_category: category.title,
                        is_distractor: false,
                        correctly_placed: false,
                    });
                });
            });
            vm.module.content.distractors.forEach(function (distractor) {
                vm.remainingOptions.push({
                    title: distractor,
                    correct_category: "none",
                    is_distractor: true,
                    correctly_placed: false,
                });
            });

            vm.response = {
                categories: vm.categories,
                remaining_options: vm.remainingOptions,
                module_complete: false,
            };
        } else {
            vm.response = {
                categories: this.modelValue.categories,
                remaining_options: this.modelValue.remaining_options,
                module_complete: this.modelValue.module_complete,
            };

            vm.categories = this.modelValue.categories;
            vm.remainingOptions = this.modelValue.remaining_options;
        }

        vm.remainingOptions = _.shuffle(vm.remainingOptions);
        vm.inputVal = vm.response;
        vm.ready = true;
    },
    computed: {
        inputVal: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit("update:modelValue", val);
            },
        },
    },
};
</script>

<style scoped lang="postcss">
.correct {
    @apply border-green-400 bg-green-400  text-white;
}

.incorrect {
    @apply border-red-400 bg-red-400 text-white;
}

.ghost {
    opacity: 0.3;
    background: transparent;
    color: transparent;
    border: 1px dashed #0e6196;
}
</style>
